import { crewsIndexData } from "../js-data/dummy/dummy-crews";
import {
  deleteCrew,
  getCrews,
  storeCrew,
  updateCrew
} from "../api-helpers/api-crews";
import { crewShowTabs, crewsIndexTabs } from "../js-data/crew-tab-groups";

export default {
  state: {
    isGettingCrews: false,
    isGettingCrew: false,
    crews: [],
    isStoringCrew: false,
    isUpdatingCrew: false,
    isDeletingCrew: false,
    indexTabs: crewsIndexTabs,
    showTabs: crewShowTabs,
    laborers: []
  },
  mutations: {
    setIsGettingCrews(state, bool) {
      state.isGettingCrews = bool;
    },
    setIsGettingCrew(state, bool) {
      state.isGettingCrew = bool;
    },
    setCrews(state, crews) {
      state.crews = crews;
    },
    setCrewsIndexTabsCounts(state, counts) {
      state.indexTabs = state.indexTabs.map(tab => {
        tab.count = counts[tab.slug];
        return tab;
      });
    },
    setIsStoringCrew(state, bool) {
      state.isStoringCrew = bool;
    },
    setIsUpdatingCrew(state, bool) {
      state.isUpdatingCrew = bool;
    },
    setIsDeletingCrew(state, bool) {
      state.isDeletingCrew = bool;
    },
    setLaborers(state, laborers) {
      state.laborers = laborers;
    },
    setCrewShowTabsCounts(state, counts) {
      state.showTabs = state.showTabs.map(tab => {
        tab.count = counts[tab.slug];
      });
    }
  },
  actions: {
    async getCrews({ commit, state }) {
      let crewsAndCounts = null;
      if (!state.isGettingCrews) {
        commit("setIsGettingCrews", true);

        crewsAndCounts = await getCrews();
        commit("setCrews", crewsAndCounts.crews);
        commit("setCrewsIndexTabsCounts", crewsAndCounts.counts);

        commit("setIsGettingCrews", false);
      }

      return crewsAndCounts;
    },
    async storeCrew({ commit, state, rootState, dispatch }, crew) {
      let response;
      if (!state.isStoringCrew) {
        commit("setIsStoringCrew", true);

        response = await storeCrew(crew);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Crew created successfully.",
          errorText: "An error occurred while attempting to create Crew.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchCrews", rootState.Search.searchTerm);
            } else {
              dispatch("getCrews");
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsStoringCrew", false);
      }
      return response;
    },
    async updateCrew({ commit, state, rootState, dispatch }, crew) {
      let response;
      if (!state.isUpdatingCrew) {
        commit("setIsUpdatingCrew", true);

        response = await updateCrew(crew);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Crew updated successfully.",
          errorText: "An error occurred while attempting to update Crew.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchCrews", rootState.Search.searchTerm);
            } else {
              dispatch("getCrews");
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsUpdatingCrew", false);
      }
      return response;
    },
    async deleteCrew({ state, rootState, commit, dispatch }, crew) {
      let response;
      if (!state.isDeletingCrew) {
        commit("setIsDeletingCrew", true);

        response = await deleteCrew(crew);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Crew deleted successfully.",
          errorText: "An error occurred while attempting to delete Crew.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchCrews", rootState.Search.searchTerm);
            } else {
              dispatch("getCrews");
            }
            commit("resetConfirmationModalParams");
          }
        });

        commit("setIsDeletingCrew", false);
      }
      return response;
    },
    getCrew({ commit, state }, crewId) {
      // Once we have an API, we will use this space to do the AJAX stuffs
      commit("setIsGettingCrew", true);
      // First try to find the crew in the store
      let crew = undefined;
      if (state.crews && state.crews.length) {
        crew = state.crews.find(crew => {
          return `${crew.id}` === `${crewId}`;
        });
      }

      if (!crew) {
        // Shoot off a request to the API here once we've got it
        const crews =
          window.localStorage.crews &&
          JSON.parse(window.localStorage.crews).length
            ? JSON.parse(window.localStorage.crews)
            : crewsIndexData.crews;

        commit("setCrews", crews);
      }

      commit("setIsGettingCrew", false);
    }
  }
};
